import { QuestionType, structuredAddressFromValues, type StructuredAddress } from "@simplyk/common";

import type { ParticipantAnswers } from "@/common/types/ticketing";
import { QuestionOutput } from "@/common/types/trpc";

export interface BuyerPrefillFromParticipants {
  email?: string;
  firstName?: string;
  lastName?: string;
  address?: StructuredAddress;
}

const toTrimmedString = (value: unknown): string => (typeof value === "string" ? value.trim() : "");

export const getBuyerPrefillFromParticipants = (
  participants: readonly ParticipantAnswers[] | undefined,
  questions: QuestionOutput[]
): BuyerPrefillFromParticipants => {
  const answers = participants?.[0]?.answers;
  if (!answers?.length) {
    return {};
  }

  const questionType = (questionId: string) => questions.find((question) => question.id === questionId)?.type;
  const emailAnswer = answers.find((answer) => questionType(answer.questionId) === QuestionType.Email);
  const nameAnswer = answers.find((answer) => questionType(answer.questionId) === QuestionType.Name);
  const addressAnswer = answers.find((answer) => questionType(answer.questionId) === QuestionType.Address);
  const address = addressAnswer ? structuredAddressFromValues(addressAnswer.answers) : undefined;

  return {
    email: toTrimmedString(emailAnswer?.answers?.[0]) || undefined,
    firstName: toTrimmedString(nameAnswer?.answers?.[0]) || undefined,
    lastName: toTrimmedString(nameAnswer?.answers?.[1]) || undefined,
    address,
  };
};
